module.exports = __webpack_public_path__ + "img/nvfashi.a159f0b8.png";